import useRouteQuery from "../common/useRouteQuery";
import { useQuery } from "react-query";
import businessRepo from "../../API/LayoutApi/business.repo";

function useBusinessList({
  pageRouteQuery = "page",
  searchRouteQuery = "search",
  isActiveRouteQuery = "is_active",
} = {}) {
  const [page, setPage] = useRouteQuery(1, pageRouteQuery, (v) => Number(v));
  const [search, setSearch] = useRouteQuery("", searchRouteQuery, (v) =>
    String(v)
  );
  const [isActive, setIsActive] = useRouteQuery("", isActiveRouteQuery, (v) =>
    String(v)
  );

  const { isLoading, isFetching, data, refetch } = useQuery({
    queryKey: ["businesses", page, search, isActive],
    queryFn: () =>
      businessRepo.getBusinesses({
        page,
        perPage: 10,
        search: search ? search : undefined,
        is_active: isActive ? JSON.parse(isActive) : undefined,
      }),
    refetchOnWindowFocus: false,
  });

  return {
    page,
    setPage,
    search,
    setSearch,
    isActive,
    setIsActive,
    isLoading,
    isFetching,
    data,
    refetch,
  };
}

export default useBusinessList;
